<app-header></app-header>

<div class="container">
  <div class="background">
    <div class="dashboard">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
